export enum GameMenuKey {
  'Overview' = 'overview',
  'GameInfo' = 'game-info',
  'AllProduct' = 'all-product',
}

export enum GameUpdateRouteType {
  UpdateGameID,
  UpdateEnvID,
  UpdateServiceID,
}
